import http from "../../utils/http"

/**
 * 获取公共分类列表
 */
export function publictypeList(params) {
    return http({
        url: "/api/PublicType/list",
        data: params
    })
}

/**
 * 获取公共分类列表
 */
 export function publictypeInfo(params) {
    return http({
        url: "/api/PublicType/info",
        data: params
    })
}
